import { useSelector } from 'react-redux'
import React, { useCallback, useContext, useEffect } from 'react'
import { Form, Formik } from 'formik'
import * as Yup from 'yup'

import { ReactComponent as CircleAdmiration } from '../../assets/icons/CircleAdmiration.svg'
import { WelcomeMessage, PageCarousel, Button, YesNoQuestion } from '../../components'
import { stringSchema, whenStringSchema } from '../../services/schemas'
import SelectedRol from './SelectedRol/SelectedRol'
import FormProfile from './FormProfile/FormProfile'
import { useFetch } from '../../services/hooks';
import Context from '../../store/context'
import utils from '../../services/utils'
import { paths } from '../../routes'
import apiMethods from '../../apis';

import classes from './WelcomeMelo.module.scss'

const initialValues = {
  page: 0,
  rol: '',
  typeOfPerson: '',
  businessName: '',
  name: '',
  identificationNumber: '',
  regime: ''
};

const message = 'Campo requerido';
const validationSchema = Yup.object().shape({
  rol: whenStringSchema('page', 1, message),
  typeOfPerson: whenStringSchema('page', 2, message),
  businessName: Yup.string().when('page', { is: 2, then: whenStringSchema('typeOfPerson', '1', message) }),
  name: Yup.string().when('page', { is: 2, then: whenStringSchema('typeOfPerson', '2', message) }),
  identificationType: whenStringSchema('page', 2, message),
  identificationNumber: whenStringSchema('page', 2, message),
  regime: whenStringSchema('page', 2, message),
});

const WelcomeMelo = () => {

  const { businessId, userId, profile } = useSelector(state => state.userData);

  const {
    isSuccess: updateSuccess,
    sendRequest: updateBusiness,
    isError: updateError,
    data: businessData,
    errorMessage: errorMessageUpdate
  } = useFetch(apiMethods.updateBusiness);

  const { sendRequest: updateUser } = useFetch(apiMethods.updateUser);
  const { modal: { hideModal, showModal, showError, showSuccess } } = useContext(Context);

  // // const setBusinessDemographyIsComplete = useCallback(() => { // Setear variables en redux
  // //   dispatch(setBusinessValue({ businessId, key:'businessDemographyIsComplete', value: true }));
  // // }, [businessId, dispatch])

  useEffect(() => {
    if (updateSuccess) {
      showSuccess({
        title: '¡Completaste exitosamente tus datos!',
        description: (
          <div>
             Esto nos permitirá brindarte una experiencia más personalizada
          </div>
        ),
        // // callback: setBusinessDemographyIsComplete
      });
    } else if (updateError) {
      showError({ title: 'Actualización negocio', description: errorMessageUpdate });
    }
  }, [errorMessageUpdate, showError, showSuccess, updateError, updateSuccess]);

  const closeSesion = () => {
    hideModal();
  };

  const formHandler = (value, helper) => {
    const _page = value.page + 1;
    if (_page === 3) {
      sendFormRegister(value);
    } else {
      helper.setFieldValue('page', (_page));
    }
  }

  const formHandlerBack = (value, setFieldValue) => {
    setFieldValue('page', (value.page - 1));
  }

  const sendFormRegister = (value) => {
    const _body = {
      name: value.name,
      email: profile.email,
      regime: value.regime,
      phone: profile.phone,
      typeOfPerson: value.typeOfPerson,
      businessName: value.businessName,
      phoneIndicative: profile.phoneIndicative,
      identificationNumber: value.identificationNumber,
    };
    updateBusiness(businessId, { demography: _body, rol: value.rol, GSI3PK: value.rol, GSI3SK: value.rol });
    const isCompleteRegister = true;
    updateUser(userId, { ...utils.dateToSendEmailMarketing(utils.statusEmailMarketing.FIRSTPAY, 20), isCompleteRegister });
  }

  return (
    <div className={classes.content}>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={formHandler}>
        {({ setFieldValue, values, errors, touched, status }) => (
          <Form>
            {values.page === 0 && <WelcomeMessage />}
            {values.page === 1 && <SelectedRol setFieldValue={setFieldValue} rol={values.rol} />}
            {values.page === 2 && <FormProfile />}
            <div className={classes['content-buttons']}>
              <PageCarousel pages={3} page={values.page} />
              <div className={classes.buttons}>
                <Button custom='secondary' onClick={ values.page === 0 ? closeSesion:() => formHandlerBack(values, setFieldValue)}>
                  {
                    values.page === 0 ? 'Ahora no':'Atras'
                  }
                </Button>
                <Button type='submit'>Continuar</Button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default WelcomeMelo;
